
import { computePosition, flip, shift, offset, arrow } from '@floating-ui/dom';

export default function initShare(){

	const handleShareBtnClick = (event) => {
		event.preventDefault();
		let shareBtn = event.target.closest('.js-share-btn');
		if(!shareBtn){
			return;
		}
		let target = shareBtn.parentNode;
		let create = true;
		const existingPopover = document.querySelectorAll( '.popover' );
		if ( existingPopover ) {
			existingPopover.forEach( (popover) => {
				const id = target.getAttribute('aria-describedby');
				const element = document.getElementById(id);
				if(element){
					create = false;
				}
				popover.remove();
			});
		}
		if(create){
			// Track share popover opening in Google Analytics
			if (typeof gtag !== 'undefined') {
				gtag('event', 'share_popover_open', {
					item_id: shareBtn.getAttribute('data-id') || 'unknown',
					item_title: shareBtn.getAttribute('data-title') || 'Unknown Item',
					context: 'content_sharing'
				});
			}

			const targetRect = target.getBoundingClientRect();
			const targetWidth = targetRect.width;
			// let content = document.getElementById('share-popover').cloneNode(true).innerHTML;
			let content = `<div class="share-popover">
				<a class="item copy-link" href="{{link}}" rel="nofollow">
					<span class="icon icon-share-link"></span> <span class="copy">Copy Link</span> <span class="visually-hidden"> to Clipboard for Sharing</span>
				</a>
				<a class="item" href="{{facebook_link}}" rel="nofollow" target="_blank">
					<span class="icon icon-facebook"></span> <span class="copy">Share on Facebook</span>
				</a>
				<!-- <a class="item" href="{{instagram_link}}" target="_blank">
					<span class="icon icon-instagram"></span> <span class="copy">Share on Instagram</span>
				</a> -->
				<a class="item" href="{{x_link}}" rel="nofollow" target="_blank">
					<span class="icon icon-x"></span> <span class="copy">Share on X</span>
				</a>
				<a class="item share-email" href="{{email_link}}" rel="nofollow" target="_blank">
					<span class="icon icon-email"></span> <span class="copy">Share by Email</span>
				</a>
			</div>
			`;
			
			let destination = location.href;
			let title = shareBtn.getAttribute('data-title');
			if (title) {
				const url = new URL(destination);
				url.searchParams.set('query', title);
				destination = url.toString();
			}

			const closestCard = target.closest( '.post-card' );
			if ( closestCard ) {
				const anchorLink = closestCard.querySelector( 'a:not(.js-share-btn, .js-favorite-btn, [href*="appointment-request"])' );
				if ( anchorLink ) {
					destination = anchorLink.href;
				}
			}


			content = content.replace("{{facebook_link}}", "https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(destination));
			content = content.replace("{{instagram_link}}", "https://www.instagram.com/sharer.php?u="+encodeURIComponent(destination));
			content = content.replace("{{x_link}}", "http://www.twitter.com/share?url="+encodeURIComponent(destination));
			content = content.replace("{{email_link}}", 'mailto:?body='+encodeURIComponent(location.href));
			content = content.replace("{{link}}", destination);

			// Create popover element
			const popover = document.createElement('div');
			popover.className = 'popover share-popover-floating';
			popover.innerHTML = content;
			popover.style.position = 'absolute';
			popover.style.top = '0';
			popover.style.left = '0';
			popover.style.zIndex = '9999';
			popover.style.visibility = 'hidden';
			
			// Add accessibility attributes
			popover.setAttribute('role', 'dialog');
			popover.setAttribute('aria-label', 'Share options');
			
			// Create arrow element
			// const arrowElement = document.createElement('div');
			// arrowElement.className = 'popover-arrow';
			// popover.appendChild(arrowElement);

			// Insert popover right after the target element to maintain tab flow
			target.insertAdjacentElement('afterend', popover);

			// Generate unique ID for accessibility
			const popoverId = 'share-popover-' + Date.now();
			popover.id = popoverId;
			target.setAttribute('aria-describedby', popoverId);

			// Position with Floating UI
			const updatePosition = async () => {
				const { x, y, placement, middlewareData } = await computePosition(target, popover, {
					placement: 'bottom',
					middleware: [
						offset(8),
						flip(),
						shift({ padding: 5 }),
						// arrow({ element: arrowElement })
					]
				});

				Object.assign(popover.style, {
					left: `${x}px`,
					top: `${y}px`,
					visibility: 'visible'
				});

				// Trigger animation by adding a small delay
				requestAnimationFrame(() => {
					popover.style.opacity = '1';
					popover.style.transform = 'scale(1)';
				});

				// Position arrow
				if (middlewareData.arrow) {
					const { x: arrowX, y: arrowY } = middlewareData.arrow;
					const side = placement.split('-')[0];
					
					// Add placement data attribute for CSS styling
					// arrowElement.setAttribute('data-placement', placement);
					
					const staticSide = {
						top: 'bottom',
						right: 'left',
						bottom: 'top',
						left: 'right'
					}[side];

					// Object.assign(arrowElement.style, {
					// 	left: arrowX != null ? `${arrowX}px` : '',
					// 	top: arrowY != null ? `${arrowY}px` : '',
					// 	right: '',
					// 	bottom: '',
					// 	[staticSide]: '-4px'
					// });
				}
			};

			updatePosition();

			// Setup copy link functionality
			const copyLinks = popover.querySelectorAll('.copy-link');
			if (copyLinks.length) {
				copyLinks.forEach( (copyLink) => {
					copyLink.addEventListener('click', (event) => {
						event.preventDefault();
						copyLink.querySelector('.copy').textContent = 'Copied!';
						navigator.clipboard.writeText(copyLink.getAttribute('href'));

						// Track copy link action in Google Analytics
						if (typeof gtag !== 'undefined') {
							gtag('event', 'share', {
								method: 'clipboard',
								item_id: shareBtn.getAttribute('data-id') || 'unknown',
								item_title: shareBtn.getAttribute('data-title') || 'Unknown Item',
								context: 'content_sharing'
							});
						}

						return false;
					});
				});
			}

			// Setup tracking for social share links
			const shareLinks = popover.querySelectorAll('.item:not(.copy-link)');
			shareLinks.forEach( (shareLink) => {
				shareLink.addEventListener('click', () => {
					// Determine share method based on URL or class
					let method = 'unknown';
					const href = shareLink.getAttribute('href');
					if (href.includes('facebook.com')) {
						method = 'facebook';
					} else if (href.includes('twitter.com')) {
						method = 'twitter';
					} else if (href.includes('mailto:')) {
						method = 'email';
					} else if (href.includes('instagram.com')) {
						method = 'instagram';
					}

					// Track social share action in Google Analytics
					if (typeof gtag !== 'undefined') {
						gtag('event', 'share', {
							method: method,
							item_id: shareBtn.getAttribute('data-id') || 'unknown',
							item_title: shareBtn.getAttribute('data-title') || 'Unknown Item',
							context: 'content_sharing'
						});
					}
				});
			});

			// Ensure accessibility for screen readers and keyboard navigation
			const focusableItems = popover.querySelectorAll('.item');
			focusableItems.forEach(item => {
				// Ensure all items are focusable (links should already be focusable by default)
				if (!item.hasAttribute('tabindex') && item.tagName !== 'A') {
					item.setAttribute('tabindex', '0');
				}
			});

			// Handle click outside to close
			const handleClickOutside = (event) => {
				if (!event.target.closest('.popover') && !event.target.closest('.js-share-btn')) {
					cleanup();
				}
			};

			// Handle escape key to close
			const handleKeyDown = (event) => {
				if (event.key === 'Escape') {
					cleanup();
				}
			};

			// Handle window resize/scroll to reposition
			const handleReposition = () => updatePosition();

			// Cleanup function to remove all event listeners and DOM elements
			const cleanup = () => {
				// Restore focus to the trigger button
				const shareButton = target.querySelector('.js-share-btn');
				if (shareButton) {
					shareButton.focus();
				}
				
				document.removeEventListener('click', handleClickOutside, { capture: true });
				document.removeEventListener('keydown', handleKeyDown);
				window.removeEventListener('scroll', handleReposition, true);
				window.removeEventListener('resize', handleReposition);
				target.removeAttribute('aria-describedby');
				popover.remove();
			};

			document.addEventListener('click', handleClickOutside, { capture: true });
			document.addEventListener('keydown', handleKeyDown);
			window.addEventListener('scroll', handleReposition, true);
			window.addEventListener('resize', handleReposition);
		}
	};


	const shareObserver = new MutationObserver( (mutations) => {
		mutations.forEach( (mutation) => {
			if (mutation.type === 'childList') {
				mutation.addedNodes.forEach( (node) => {
					if (node.nodeType === Node.ELEMENT_NODE) {
						const shareBtns = node.querySelectorAll('.js-share-btn');
						shareBtns.forEach( (shareBtn) => {
							shareBtn.addEventListener('click', handleShareBtnClick);
						});
					}
				});
			}
		});
	});
	shareObserver.observe(document.body, {
		childList: true,
		subtree: true
	});

	document.querySelectorAll('.js-share-btn').forEach( (shareBtn) => {
		shareBtn.addEventListener('click', handleShareBtnClick);
	});

}
